import React from 'react';

// Core Home Components
import HeroSection from '../components/home/HeroSection';
import ValueProps from '../components/home/ValueProps';
import CategoryGrid from '../components/home/CategoryGrid';

// Luxury Showcase Components
import TestimonialsSection from './TestimonialsSection';
import JournalSection from './JournalSection';
import NewsletterBanner from './NewsletterBanner';

const HomePage = () => {
  return (
    <main className="bg-[#FDFBF7]">

      {/* HERO */}
      <HeroSection />

      {/* BRAND VALUES */}
      <ValueProps />

      {/* SAREE COLLECTIONS */}
      <CategoryGrid />

      {/* CUSTOMER EXPERIENCES */}
      <TestimonialsSection />

      {/* VEDHYAS CONCIERGE */}
      <section className="relative mx-4 mb-14 overflow-hidden rounded-[28px] bg-[#4A0E17] px-6 py-12 text-[#FDFBF7] sm:mx-6 sm:px-10 lg:mx-auto lg:max-w-7xl lg:px-14">

        {/* Ambient glow */}
        <div className="absolute -right-32 -top-32 h-80 w-80 rounded-full bg-[#C19A5B]/15 blur-3xl" />

        <div className="absolute -bottom-32 -left-32 h-72 w-72 rounded-full bg-[#C19A5B]/10 blur-3xl" />

        <div className="relative z-10 mx-auto max-w-3xl text-center">

          <span className="mb-4 inline-flex rounded-full border border-[#E8DFC8]/20 bg-white/10 px-4 py-2 text-[9px] font-semibold uppercase tracking-[0.22em] text-[#E8DFC8] backdrop-blur-md">
            VEDHYAS Experience
          </span>

          <h2 className="font-serif text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
            Elegance, Chosen
            <span className="block text-[#E4C891]">
              Just For You
            </span>
          </h2>

          <p className="mx-auto mt-4 max-w-xl text-xs leading-6 text-[#E8DFC8]/80 sm:text-sm">
            Discover sarees thoughtfully selected for celebrations,
            everyday elegance and unforgettable moments.
          </p>

        </div>
      </section>

      {/* CRAFTSMANSHIP */}
      <JournalSection />

      {/* NEWSLETTER */}
      <NewsletterBanner />

    </main>
  );
};

export default HomePage;